import ModulePlanningLecturerResourceModel from '../../generated/types/model/resource/ModulePlanningLecturerResourceModel';

export default class ModulePlanningLecturerResourceViewModel extends ModulePlanningLecturerResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
